// The `task_ref` block a card gains when a task is captured from it.
import type { CardBlock } from "@shared/core";

export interface TaskRef {
  taskId: string;
  title: string;
}

function refOf(block: CardBlock): TaskRef | null {
  if (block.type !== "task_ref" || !block.taskId) return null;
  return { taskId: block.taskId, title: (block.value ?? block.text ?? "").trim() || "Task" };
}

/** The task a capture just added: a task_ref in `after` that `before` did not have. */
export function newTaskRef(
  before: readonly CardBlock[],
  after: readonly CardBlock[],
): TaskRef | null {
  const known = new Set(before.map(refOf).flatMap((r) => (r ? [r.taskId] : [])));
  const fresh = after.map(refOf).filter((r): r is TaskRef => !!r && !known.has(r.taskId));
  return fresh[fresh.length - 1] ?? null;
}
